// CAT Mock 4 — QA section.
const catMock4Qa = [
  {
    id: 47,
    type: "mcq",
    question: "An article is sold at a profit of 20%. Had it been bought for 10% less and sold for ₹18 less, the profit would have been 25%. What is the cost price of the article?",
    options: [
      "A. ₹200",
      "B. ₹250",
      "C. ₹240",
      "D. ₹300"
    ],
    answer: "C"
  },
  {
    id: 48,
    type: "tita",
    question: "A boat travels 30 km upstream and 44 km downstream in 10 hours. It travels 40 km upstream and 55 km downstream in 13 hours. What is the speed of the boat in still water (in km/h)?",
    answer: "8"
  },
  {
    id: 49,
    type: "mcq",
    question: "What is the sum of all the positive divisors of 360?",
    options: [
      "A. 1080",
      "B. 1170",
      "C. 1260",
      "D. 1210"
    ],
    answer: "B"
  },
  {
    id: 50,
    type: "tita",
    question: "How many four-digit numbers have digits that are strictly increasing from left to right?",
    answer: "126"
  },
  {
    id: 51,
    type: "mcq",
    question: "In a circle, a chord of length 24 cm is at a distance of 5 cm from the centre. What is the length of a chord of the same circle that is at a distance of 12 cm from the centre?",
    options: [
      "A. 8 cm",
      "B. 12 cm",
      "C. 14 cm",
      "D. 10 cm"
    ],
    answer: "D"
  },
  {
    id: 52,
    type: "tita",
    question: "Alloy X contains gold and copper in the ratio 3 : 2 and alloy Y contains them in the ratio 5 : 3. If 10 kg of X is melted with some quantity of Y to obtain an alloy with gold and copper in the ratio 31 : 19, how many kg of Y are used?",
    answer: "40"
  },
  {
    id: 53,
    type: "mcq",
    question: "If a + b + c = 0 and a, b, c are non-zero, then a²/(bc) + b²/(ca) + c²/(ab) equals:",
    options: [
      "A. 3",
      "B. 0",
      "C. 1",
      "D. abc"
    ],
    answer: "A"
  },
  {
    id: 54,
    type: "tita",
    question: "Given that log₁₀2 = 0.30103, how many digits does 2⁵⁰ have?",
    answer: "16"
  },
  {
    id: 55,
    type: "mcq",
    question: "Two fair dice are thrown. What is the probability that the product of the numbers shown is a multiple of 6?",
    options: [
      "A. 1/3",
      "B. 11/36",
      "C. 5/12",
      "D. 1/2"
    ],
    answer: "C"
  },
  {
    id: 56,
    type: "tita",
    question: "If x and y are positive real numbers such that 3x + 4y = 48, what is the maximum possible value of xy?",
    answer: "48"
  },
  {
    id: 57,
    type: "mcq",
    question: "What is the value of 1/(1·3) + 1/(3·5) + 1/(5·7) + … + 1/(19·21)?",
    options: [
      "A. 9/19",
      "B. 10/21",
      "C. 20/21",
      "D. 11/21"
    ],
    answer: "B"
  },
  {
    id: 58,
    type: "tita",
    question: "What is the remainder when 5²⁰²⁵ is divided by 13?",
    answer: "5"
  },
  {
    id: 59,
    type: "mcq",
    question: "For which values of x is (x² − 7x + 10)(x² − 9x + 18) < 0?",
    options: [
      "A. 2 < x < 6",
      "B. 3 < x < 5",
      "C. x < 2 or x > 6",
      "D. 2 < x < 3 or 5 < x < 6"
    ],
    answer: "D"
  },
  {
    id: 60,
    type: "tita",
    question: "Four years ago, the ages of A and B were in the ratio 5 : 3. Six years from now, their ages will be in the ratio 5 : 4. What is the sum of their present ages (in years)?",
    answer: "24"
  },
  {
    id: 61,
    type: "mcq",
    question: "A can complete a job in 10 days and B in 15 days. With the help of C, the three together complete it in 5 days. If the total payment for the job is ₹4,500 and it is shared in proportion to the work done, what is C's share?",
    options: [
      "A. ₹600",
      "B. ₹900",
      "C. ₹750",
      "D. ₹1,000"
    ],
    answer: "C"
  },
  {
    id: 62,
    type: "tita",
    question: "How many triangles can be formed by joining vertices of a regular 12-sided polygon such that no side of the triangle is also a side of the polygon?",
    answer: "112"
  },
  {
    id: 63,
    type: "mcq",
    question: "What is the distance between the parallel lines 3x + 4y = 12 and 6x + 8y + 11 = 0?",
    options: [
      "A. 3.5 units",
      "B. 2.3 units",
      "C. 4.6 units",
      "D. 1.7 units"
    ],
    answer: "A"
  },
  {
    id: 64,
    type: "tita",
    question: "A sum of money doubles itself in 8 years at simple interest. In how many years will it become 3.5 times itself at the same rate?",
    answer: "20"
  },
  {
    id: 65,
    type: "mcq",
    question: "The radius of a right circular cone is increased by 20% and its height is decreased by 25%. By what percentage does its volume change?",
    options: [
      "A. Decreases by 8%",
      "B. Increases by 8%",
      "C. Increases by 12%",
      "D. Decreases by 10%"
    ],
    answer: "B"
  },
  {
    id: 66,
    type: "tita",
    question: "f(x) = ax + b, where a > 0, and f(f(x)) = 9x + 8 for all x. What is the value of f(5)?",
    answer: "17"
  },
  {
    id: 67,
    type: "mcq",
    question: "The HCF of two numbers is 27 and their LCM is 2079. If one of the numbers is 189, what is the other?",
    options: [
      "A. 243",
      "B. 351",
      "C. 297",
      "D. 315"
    ],
    answer: "C"
  },
  {
    id: 68,
    type: "tita",
    question: "Three numbers in geometric progression have a sum of 21 and a product of 216. What is the sum of their squares?",
    answer: "189"
  }
];

export default catMock4Qa;
